export const sortPorts = (a, b) => a.order - b.order;
